
import hollowTopIcon from './dir/hollow-top.svg';
import hollowBottomIcon from './dir/hollow-bottom.svg';
import hollowBottomDisIcon from './dir/hollow-bottom-disabled.svg';
import hollowBottomWhiteIcon from './dir/hollow-bottom-white.svg';
import hollowLeftIcon from './dir/hollow-left.svg';
import hollowLeftDisIcon from './dir/hollow-left-disabled.svg';
import hollowRightIcon from './dir/hollow-right.svg';
import hollowRightDisIcon from './dir/hollow-right-disabled.svg';

import delCircleIcon from './delAdd/del-circle.svg';
import delIcon from './delAdd/del.svg';
import addBlueIcon from './delAdd/add-blue.svg';
import addCircleBlueIcon from './delAdd/add-circle-blue.svg';

import errorIcon from './msg/error.svg';
import successIcon from './msg/success.svg';
import infoIcon from './msg/info.svg';

import eyeIcon from './eye/eye-open.svg';
import eyeCloseIcon from './eye/eye-close.svg';

import narrowIcon from './zoom/narrow.svg';
import enlargeIcon from './zoom/enlarge.svg';

import selectIcon from './select/redio-checked.svg';
import searchIcon from './search/search.svg';

import tableIcon from './table/table.svg';
import datePickerIcon from './datePicker/date-picker.svg';

const dir = {
  hollowTopIcon,
  hollowBottomIcon,
  hollowBottomDisIcon,
  hollowBottomWhiteIcon,
  hollowLeftIcon,
  hollowLeftDisIcon,
  hollowRightIcon,
  hollowRightDisIcon
}

const actions = {
  delCircleIcon,
  delIcon,
  addBlueIcon,
  addCircleBlueIcon
}

const msg = {
  errorIcon,
  successIcon,
  infoIcon
}

const eye = {
  eyeIcon,
  eyeCloseIcon,
}

const select = {
  selectIcon
}

const search = {
  searchIcon
}

const zoom = {
  narrowIcon,
  enlargeIcon
}

export { dir, msg, actions, eye, select, zoom, search, tableIcon, datePickerIcon };